'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

/** Payment provider model */
var PaymentProvider = (0, _immutable.Record)({
    title: '',
    url: '',
    nofollow: true,
    className: '',
    target: '_self'
});


var transformPaymentProviderToModel = function transformPaymentProviderToModel(bag, paymentProvider) {
    return bag.push(new PaymentProvider(paymentProvider));
};

var transformPaymentProviderData = function transformPaymentProviderData(paymentProviders) {
    return paymentProviders.reduce(transformPaymentProviderToModel, (0, _immutable.List)());
};

exports.default = transformPaymentProviderData;
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/payment-providers/model.js
// module id = 255
// module chunks = 0